import { render, staticRenderFns } from "./CancelAddendum.vue?vue&type=template&id=3b51cba8&scoped=true&"
import script from "./CancelAddendum.vue?vue&type=script&lang=js&"
export * from "./CancelAddendum.vue?vue&type=script&lang=js&"
import style0 from "./CancelAddendum.vue?vue&type=style&index=0&id=3b51cba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b51cba8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b51cba8')) {
      api.createRecord('3b51cba8', component.options)
    } else {
      api.reload('3b51cba8', component.options)
    }
    module.hot.accept("./CancelAddendum.vue?vue&type=template&id=3b51cba8&scoped=true&", function () {
      api.rerender('3b51cba8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/addendum/CancelAddendum.vue"
export default component.exports